import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          const el = entry.target
          const delay = parseInt(el.dataset.revealDelay || "0", 10)
          if (delay) {
            setTimeout(() => el.classList.add("revealed"), delay)
          } else {
            el.classList.add("revealed")
          }
          this.observer.unobserve(el)
        })
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    )

    // Only hide elements below the fold. In-viewport (incl. LCP) content stays visible
    // so first paint never waits on JS.
    const vh = window.innerHeight || document.documentElement.clientHeight
    this.element.querySelectorAll("[data-reveal]").forEach((el) => {
      if (el.getBoundingClientRect().top < vh) {
        el.classList.add("revealed")
      } else {
        el.classList.add("reveal-init")
        this.observer.observe(el)
      }
    })

    this.boundBeforeCache = this.beforeCache.bind(this)
    document.addEventListener("turbo:before-cache", this.boundBeforeCache)
  }

  disconnect() {
    this.observer?.disconnect()
    if (this.boundBeforeCache) {
      document.removeEventListener("turbo:before-cache", this.boundBeforeCache)
    }
  }

  beforeCache() {
    this.element.querySelectorAll("[data-reveal].revealed").forEach((el) => {
      el.classList.remove("revealed")
    })
  }
}
